export const locale = {
    lang: 'ar',
    data: {
        TRANSFORM: 'حول البطاقات إلى مَهام',
        ALL_CARDS: 'جميع البطاقات',
        LIST_CARDS: 'بطاقات من القوائم',
        CATEGORIES: 'الألوان',
        CARDS_HAVE: 'البطاقات التي لديها',
        TYPE: 'النوع',
        POINTS: 'نقاط',
        OF: 'من',
        CHOOSE_CARDS: 'اختر البطاقات',
        PLUS: 'أكثر',
        MOINS: 'أقل',
        SAVE: 'حِفْظْ',
        CANCEL: 'إلغاء',
    }
};
